import RouterWrapper from './RouterWrapper';

export default RouterWrapper;
